import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { addDaysToDate, getTodayDate } from '../../helpers/date'
import { SearchAvailabilityInput } from '../../types/searchAvailability'
import SearchWidgetMain from './SearchWidgets/SearchWidgetMain'
import useStyles from './styles/index.styles'

const Booking = () => {
  const classes = useStyles()
  const params = useParams<{ channelId: string; code: string; name: string }>()

  const [readMode, setreadMode] = useState(false)
  const [searchAvailabilityInput, setSearchAvailabilityInput] =
    useState<SearchAvailabilityInput>({
      channelId: '',
      arrival: getTodayDate('en'),
      departure: addDaysToDate(getTodayDate('en'), 1),
      currency: 'IRR',
      guestsAges: [24, 24],
      sort: 'PRICE_ASC',
      showUnavailableRatePlans: true
    })

  useEffect(() => {
    setSearchAvailabilityInput((prev) => ({
      ...prev,
      channelId: params.channelId ? params.channelId : ''
    }))
  }, [params])

  return (
    <div className={classes.root}>
      <div className={classes.widgetContainer}>
        <SearchWidgetMain
          setSearchAvailabilityInput={setSearchAvailabilityInput}
          searchAvailabilityInput={searchAvailabilityInput}
          readMode={readMode}
          setreadMode={setreadMode}
          isFromBooking={true}
        />
      </div>
    </div>
  )
}
export default Booking
